// platform.js
export function isApp() {
  // 1️⃣ Capacitor
  try {
    const { Capacitor } = require('@capacitor/core')
    if (Capacitor.isNativePlatform()) return true
  } catch (e) {}

  // 2️⃣ Cordova
  if (window.cordova) return true

  // 3️⃣ WebView fallback
  const ua = navigator.userAgent || ''
  const isAndroidWebView = /wv|; wv\)/i.test(ua) || (ua.includes('Android') && !ua.includes('Chrome/'))
  const isiOSWebView = /(iPhone|iPad|iPod).*AppleWebKit(?!.*Safari)/i.test(ua)

  return isAndroidWebView || isiOSWebView
}
